var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvoiceUnselected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "invoice_unselected") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-/-icons-/-factures-(black)",
    transform: "translate(-1.000000, -1.000000)",
    fill: "#172134",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,20.999986 L4,20.999986 C3.20435,20.999986 2.44129,20.683886 1.87868,20.121286 C1.316071,19.558686 1,18.795686 1,17.999986 L1,2 C1,1.734786 1.105357,1.480426 1.292893,1.292893 C1.48043,1.105357 1.73478,1 2,1 L16,1 C16.2652,1 16.5196,1.105357 16.7071,1.292893 C16.8946,1.480426 17,1.734786 17,2 L17,13.999986 L21,13.999986 L21,17.999986 C21,18.795686 20.6839,19.558686 20.1213,20.121286 C19.5587,20.683886 18.7956,20.999986 18,20.999986 Z M17,15.999986 L17,17.999986 C17,18.265186 17.1054,18.519586 17.2929,18.707086 C17.4804,18.894686 17.7348,18.999986 18,18.999986 C18.2652,18.999986 18.5196,18.894686 18.7071,18.707086 C18.8946,18.519586 19,18.265186 19,17.999986 L19,15.999986 L17,15.999986 Z M15,18.999996 L15,2.999996 L3,2.999996 L3,17.999996 C3,18.265186 3.10536,18.519586 3.29289,18.707086 C3.48043,18.894686 3.73478,18.999996 4,18.999996 L15,18.999996 Z M5,5.999996 L13,5.999996 L13,7.999996 L5,7.999996 L5,5.999996 Z M5,9.999996 L13,9.999996 L13,11.999986 L5,11.999986 L5,9.999996 Z M5,13.999986 L10,13.999986 L10,15.999986 L5,15.999986 L5,13.999986 Z",
    id: "invoice_unselected"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceUnselected);
export default __webpack_public_path__ + "static/media/invoice_unselected.fcdcd99b458c95fbc059e241aa17661b.svg";
export { ForwardRef as ReactComponent };